<template>
	<section id="mfmm-moments">
		<div class="header">
			<h2>Choose Your Experience To Begin</h2>
			<svg-arrow/>
		</div>
		<div :class="{'moments': true, 'moments--active': openCurtains}">
			<moments-section-item type="forest" @open="open" @openMobile="openMobile">
				The calls of the wild in Japan are irresistible, from top to bottom. Go in search of them and you’ll find a land made from lush and unspoiled UNESCO-listed wilderness.<br><br>
				Japan’s northernmost region of Hokkaido is home to Shiretoko National Park - considered the last unexplored haven of Japan, where tall mountains and roaring waterfalls await. <br><br>
				Discover breathtaking vistas in Tohoku at Shirakami Sanchi, a mountain range with magnificent hiking trails and some of the most vivid blue waters you’ll ever see.<br><br>
				In Wakayama, embark on the UNESCO World Heritage listed pilgrimage routes of Kumano Kodo to reach the three Grand Shrines of Kumano. <br><br>
				In the mystical island of Yakushima in Kagoshima lies a forest of thousand-year-old cedar trees that inspired the setting for Hayao Miyazaki’s animated film <em>Princess Mononoke</em>.<br><br>
			</moments-section-item>
			<moments-section-item type="ocean" @open="open" @openMobile="openMobile">
			Japan by sea is just as exhilarating as on land. <br><br>
			The islands of Japan will leave you breathless, from the white sandy beaches and fishing mecca of the Goto Islands in Nagasaki to whale watching and swimming with dolphins at the remote UNESCO inscribed Ogasawara Islands in Tokyo.<br><br>
			Japan’s south shimmers with gorgeous beaches, colourful coral reefs and rich marine life like Amami Oshima in Kagoshima - the second largest remote island in Japan. Japan’s southernmost prefecture of Okinawa is lined with emerald green beaches with some of the best spots in the country for snorkelling and scuba diving. </moments-section-itembr><br>
			</moments-section-item>
			<moments-section-video
				video-type="forest"
				:active-video="activeVideo"
				:active-video-mobile="activeVideoMobile"
				:active-golden-moment="activeGoldenMoment"
				@showLightbox="$emit('showLightbox'); activeVideoMobile = null;" />
			<moments-section-video
				video-type="ocean"
				:active-video="activeVideo"
				:active-video-mobile="activeVideoMobile"
				:active-golden-moment="activeGoldenMoment"
				@showLightbox="$emit('showLightbox'); activeVideoMobile = null;" />
		</div>
	</section>
</template>

<script>
import * as h from '../helpers';
import SvgArrow from './SvgArrow';
import MomentsSectionItem from './MomentsSectionItem';
import MomentsSectionVideo from './MomentsSectionVideo';

export default {
	components: { SvgArrow, MomentsSectionItem, MomentsSectionVideo },
	data () {
		return {
			playingVideo: null,
			activeVideo: null, // -> Determine which video to display
			activeVideoMobile: null, // -> Determine which video to display on mobile
			activeGoldenMoment: null, // -> Activate the golden moment over the video
			openCurtains: false, // -> open the curtains...
		};
	},
	watch: {
		/**
		 * Stop & reset videos on mobile.
		 */
		activeVideoMobile: function (val) {
			if (val === null) {
				const videoEls = h.$$('.moments video');
				[...videoEls].forEach(video => {
					video.pause();
					video.currentTime = 0;
				});
			}
		},
	},
	mounted () {
		if (!this.$store.getters.isMobile) {
			this.resizeVideos();
			window.onresize = () => this.resizeVideos();
		}
	},
	methods: {
		// Open video on Desktop -> open curtains
		open (type) {
			this.openCurtains = true;
			this.activeVideo = type;
			this.$root.activeMoment = type;
			this.resizeVideos();

			this.playingVideo = h.$(`#app-mfmm .video--${type} video`);
			this.playingVideo.play();
			this.playingVideo.addEventListener('timeupdate', () => {
				// Show golden moment
				if (this.playingVideo && this.playingVideo.currentTime >= 26) {
					this.activeGoldenMoment = type;
					try {
						localStorage.setItem(type, 'finished');
					} catch (error) {}
				}
				// Show tooltip
				const tooltip = h.$(`#app-mfmm .video--${type} .video__tooltip`);
				if (this.playingVideo && this.playingVideo.currentTime <= 8) {
					tooltip.classList.add('active');
				} else {
					tooltip.classList.remove('active');
				}
			}, true);
		},

		// Open video on Mobile
		openMobile (type) {
			this.$root.activeMoment = type;
			this.activeVideoMobile = type;
			this.playingVideo = h.$(`#app-mfmm .video--${type} video`);
			this.playingVideo.play();

			const displayGoldenMoment = () => {
				if (this.playingVideo && this.playingVideo.currentTime >= 26) {
					this.activeGoldenMoment = type;
					this.positionGoldenMomentMobile();
					try {
						localStorage.setItem(type, 'finished');
					} catch (error) {}
					this.playingVideo.removeEventListener('timeupdate', displayGoldenMoment);
				}

				// Show loading
				const videoContainer = h.$(`#app-mfmm .video--${type}`);
				if (this.playingVideo.currentTime >= 1) {
					videoContainer.classList.remove('loading');
				}

				// Show tooltip
				const tooltip = h.$(`#app-mfmm .video--${type} .video__tooltip`);
				if (this.playingVideo && this.playingVideo.currentTime <= 8) {
					tooltip.classList.add('active');
				} else {
					tooltip.classList.remove('active');
				}
			};
			this.playingVideo.addEventListener('timeupdate', displayGoldenMoment, true);
		},

		// Close video / curtains on Desktop
		close () {
			this.openCurtains = false;
			return new Promise(resolve => setTimeout(() => {
				this.playingVideo.pause();
				this.playingVideo.currentTime = 0;
				this.playingVideo = null;

				this.activeVideo = null;
				this.activeGoldenMoment = null;
				resolve();
			}, 1100)); // -> The length of the closing animation is set in CSS, so we know when it ends.
		},

		// Reopen curtains on Desktop
		async reopen (type) {
			if (this.$store.state.toggledMoment) {
				// We are on mobile
				console.log(type);
				this.openMobile(type);
			} else {
				// We are on desktop
				await this.close();
				this.open(type);
			}
		},

		resizeVideos () {
			const videoEls = h.$$('.moments video');
			const maskHeight = h.$('.moment').clientHeight;
			const maskWidth = h.$('.moments').clientWidth;
			let videoWidth = 0;
			let videoHeight = 0;

			if (maskHeight / maskWidth > 1080 / 1920) {
				// Resize by height
				videoHeight = maskHeight;
				videoWidth = (1920 / 1080) * videoHeight;
			} else {
				// Resize by width
				videoWidth = maskWidth;
				videoHeight = (1080 / 1920) * videoWidth;
			}

			const heightOffset = (videoHeight - maskHeight) / -2;
			const widthOffset = (videoWidth - maskWidth) / -2;
			[...videoEls].forEach(el => {
				el.style.position = 'absolute';
				el.style.top = `${heightOffset}px`;
				el.style.left = `${widthOffset}px`;
				el.style.width = `${videoWidth}px`;
				el.style.height = `${videoHeight}px`;
			});

			// Places the active golden moment over the video based on the actual screen size.
			// 👇
			const goldenMoments = [
				{
					el: h.$('.video--ocean a'),
					x: 1010,
					y: 720,
				},
				{
					el: h.$('.video--forest a'),
					x: 860,
					y: 630,
				},
			];
			goldenMoments.forEach(goldenMoment => {
				if (goldenMoment.el) {
					const {clientWidth: goldenWidth, clientHeight: goldenHeight} = goldenMoment.el;
					const resizeWidthRatio = goldenMoment.x / 1920;
					const resizeHeightRatio = goldenMoment.y / 1080;
					goldenMoment.el.style.top = `${(videoHeight * resizeHeightRatio) + heightOffset + goldenHeight / -2}px`;
					goldenMoment.el.style.left = `${(videoWidth * resizeWidthRatio) + widthOffset + goldenWidth / -2}px`;
				}
			});
		},

		positionGoldenMomentMobile () {
			const goldenMoments = [
				{
					el: h.$('.video--ocean a'),
					x: 214,
					y: 370,
				},
				{
					el: h.$('.video--forest a'),
					x: 133,
					y: 324,
				},
			];
			goldenMoments.forEach(goldenMoment => {
				if (goldenMoment.el) {
					const {clientWidth: videoWidth, clientHeight: videoHeight} = h.$('.video--activeMobile video');
					const heightOffset = (h.$('.video--activeMobile').clientHeight - videoHeight) / 2;
					const {clientWidth: goldenWidth, clientHeight: goldenHeight} = goldenMoment.el;
					const resizeWidthRatio = goldenMoment.x / 374;
					const resizeHeightRatio = goldenMoment.y / 558;
					goldenMoment.el.style.top = `${(videoHeight * resizeHeightRatio) + heightOffset + goldenHeight / -2}px`;
					goldenMoment.el.style.left = `${(videoWidth * resizeWidthRatio) + goldenWidth / -2}px`;
				}
			});
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../assets/_mixins.less';
	@import (reference) '../assets/_breakpoints.less';
	@height: 45vw;

	.header { position: relative; z-index: 10; display: flex; flex-direction: column; justify-content: center; align-items: center; margin: -13px 0; padding: 40px 0; height: image-height('../assets/bg-delimiter.png'); background: transparent url(../assets/bg-delimiter.png) 0 0 repeat-x; text-align: center;
		h2 { margin-bottom: 20px; color: black; font-size: 30px; text-align: center; font-weight: 500; }
		svg { fill: #E90206; width: 66px; }
	}

	.moments { position: relative; display: flex; overflow: hidden; padding-bottom: 70px;
		&--active {
			.moment {
				&--forest { transform: translateX(-100%); }
				&--ocean { transform: translateX(+100%); }
			}
		}
		&:after { content: ""; display: block; .size(100%, 100px); .bottom-left(0, 0, 10); background: transparent url(../assets/bg-delimiter.png) 0 0 repeat-x; }
	}

	@media @mobile {
		.moments { flex-direction: column-reverse; padding-bottom: 0;
			&:after { height: 20px; background-position: 50% 0%; background-repeat: repeat-x; }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/MomentsSection.vue